import { COVERAGE_TYPE } from "./aquafina";

export const NOT_OFFERED = "Not Offered";

export const VIEW_MODES = {
  POLICY: "policy",
  PROPOSAL: "proposal",
} as const;

export enum PolicyVariants {
  BASIC_LIFE = "basiclife",
  DENTAL_INDEMNITY = "dentalIndemnity",
  DENTAL_PPO = "dentalPPO",
  DENTAL_EPO = "dentalEPO",
  DENTAL_HMO = "dentalHMO",
  DENTAL_POS = "dentalPOS",
  LTD = "ltd",
  STD = "std",
  VISION = "vision",
  VOLUNTARY_LIFE = "voluntarylife",
  MEDICAL = "medical",
  HOSPITAL_INDEMNITY = "hospitalIndemnity",
  ACCIDENT = "accident",
  CRITICAL_ILLNESS = "criticalIllness",
}

export const POLICY_VARIANT_AQUAFINA_COVERAGE_TYPE_MAPPING: Record<
  PolicyVariants,
  (typeof COVERAGE_TYPE)[keyof typeof COVERAGE_TYPE]
> = {
  [PolicyVariants.BASIC_LIFE]: COVERAGE_TYPE.BASIC_LIFE,
  [PolicyVariants.DENTAL_INDEMNITY]: COVERAGE_TYPE.DENTAL,
  [PolicyVariants.DENTAL_PPO]: COVERAGE_TYPE.DENTAL,
  [PolicyVariants.DENTAL_EPO]: COVERAGE_TYPE.DENTAL,
  [PolicyVariants.DENTAL_HMO]: COVERAGE_TYPE.DENTAL,
  [PolicyVariants.DENTAL_POS]: COVERAGE_TYPE.DENTAL,
  [PolicyVariants.LTD]: COVERAGE_TYPE.LTD,
  [PolicyVariants.STD]: COVERAGE_TYPE.STD,
  [PolicyVariants.VISION]: COVERAGE_TYPE.VISION,
  [PolicyVariants.VOLUNTARY_LIFE]: COVERAGE_TYPE.VOLUNTARY_LIFE,
  [PolicyVariants.MEDICAL]: COVERAGE_TYPE.MEDICAL,
  [PolicyVariants.HOSPITAL_INDEMNITY]: COVERAGE_TYPE.HOSPITAL_INDEMNITY,
  [PolicyVariants.ACCIDENT]: COVERAGE_TYPE.ACCIDENT,
  [PolicyVariants.CRITICAL_ILLNESS]: COVERAGE_TYPE.CRITICAL_ILLNESS,
};

export const policyVariantsTitleMap: Record<PolicyVariants, string> = {
  [PolicyVariants.BASIC_LIFE]: "Basic Life",
  [PolicyVariants.DENTAL_INDEMNITY]: "Dental Indemnity",
  [PolicyVariants.DENTAL_PPO]: "Dental PPO",
  [PolicyVariants.DENTAL_EPO]: "Dental EPO",
  [PolicyVariants.DENTAL_HMO]: "Dental HMO",
  [PolicyVariants.DENTAL_POS]: "Dental POS",
  [PolicyVariants.LTD]: "LTD",
  [PolicyVariants.STD]: "STD",
  [PolicyVariants.VISION]: "Vision",
  [PolicyVariants.VOLUNTARY_LIFE]: "Voluntary Life",
  [PolicyVariants.MEDICAL]: "Medical",
  [PolicyVariants.HOSPITAL_INDEMNITY]: "Hospital Indemnity",
  [PolicyVariants.ACCIDENT]: "Accident Insurance",
  [PolicyVariants.CRITICAL_ILLNESS]: "Critical Illness",
};

export const DENTAL_VARIANT_PLAN_TYPE_MAPPING = {
  [PolicyVariants.DENTAL_EPO]: "epo",
  [PolicyVariants.DENTAL_PPO]: "ppo",
  [PolicyVariants.DENTAL_HMO]: "hmo",
  [PolicyVariants.DENTAL_POS]: "pos",
  [PolicyVariants.DENTAL_INDEMNITY]: "indemnity",
} as const;
